import React, { useEffect, useState, useRef } from 'react';
import './login.css';
import Logo from '../../assets/images/image.png';
import Leaf from '../../assets/images/leaf.png';
import Info from '../../assets/icons/info.svg';
import { sendCodeApi, loginApi, CheckMobile } from '../../utils/api';
import { Toast } from 'primereact/toast';
import Form from 'react-bootstrap/Form';
import Loadr from '../loader/loader'
import { Tooltip } from 'primereact/tooltip';

function Profile() {
    const toast = useRef(null);
    const [checkMobile, setCheckMobile] = useState(true);
    const [time, setTime] = useState(120); // Initialize with 2 minutes (120 seconds)
    const [isActive, setIsActive] = useState(false);
    const [resendBtn, setResendBtn] = useState(true);
    const [resendCode, setResendCode] = useState(false);
    const [passwordSection, setPasswordSection] = useState(false);
    const [mobile, setMobile] = useState('');
    const [password, setPassword] = useState('');
    const [first, setFirst] = useState('');
    const [verifyPassword, setVerifyPassword] = useState('');
    const [validated, setValidated] = useState(false);
    const [passValidated, setPassValidated] = useState(false);
    const [loginLoader, setLoginLoader] = useState(false);
    const [sendMobileLoader, setSendMobileLoader] = useState(false);
    const [sendCodeLoader, setSendCodeLoader] = useState(false);
    const otpRef = useRef(null); // Reference to OTP input
    useEffect(() => {
        const handleResize = () => {
            const height = window.innerHeight;
            document.body.classList.toggle('keyboard-active', window.innerHeight < height);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // const getMessage = () => {
    //     if ('sms' in navigator) {
    //         navigator.sms.addEventListener('message', (event) => {
    //             if (otpRef.current) {
    //                 otpRef.current.value = event.data;
    //             }
    //         });
    //     } 
    // };




    //set error and success message
    const showError = (error) => {
        toast.current.show({ severity: 'error', detail: error.text, life: 6000 });
    }
    const showSuccess = (success) => {
        toast.current.show({ severity: 'success', detail: success.text, life: 6000 });
    }


    //get IPAddress for login
    const getIPAddress = async () => {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            return data.ip;
        } catch (error) {
            console.error('Failed to fetch IP address:', error);
            return null;
        }
    }

    //check Mobile
    const sendMobile = async (event) => {
        event.preventDefault(); // Prevent the default form submission
        const form = event.currentTarget;

        //validation
        if (form.checkValidity() === true) {
            event.stopPropagation();
            if (mobile.length >= 10) {
                setSendMobileLoader(true)
                try {
                    let check = await CheckMobile(mobile)
                    if (check.data.res === 'NotOK') {
                        let error = {
                            title: 'هشدار',
                            text: check.data.resTp,
                        }
                        showError(error)
                        setSendMobileLoader(false)
                    } else {
                        let pay = {
                            text: check.data.resTp
                        }
                        showSuccess(pay)
                        setCheckMobile(false);
                        setFirst(check.data.first)
                        setSendMobileLoader(false)
                    }
                } catch (error) {
                    setSendMobileLoader(false)
                }

            } else {
                let error = {
                    title: 'اخطار',
                    text: 'شماره موبایل وارد شده صحیح نمیباشد',
                }
                showError(error);
                setSendMobileLoader(false)
            }
        }
        setValidated(true);
    }

    //send mobile and get password
    const getPassword = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
    
        // Set interval for timer
        setResendCode(false);
        setTime(120);
    
        if (form.checkValidity() === true) {
            event.stopPropagation();
    
            try {
                setSendCodeLoader(true);
                let response = await sendCodeApi(mobile);
    
                if (response.data.res === 'OK') {
                    console.log('...', 'OTPCredential' in window);
    
                    // بررسی پشتیبانی مرورگر از OTPCredential API
                    if ('OTPCredential' in window) {
                        // ایجاد کنترلر برای متوقف کردن در صورت دریافت کد یا ارسال فرم
                        var ac = new AbortController();
    
                        // ایجاد یک تایمر برای مدت زمان انتظار برای پیامک (2 دقیقه به عنوان مثال)
                        const otpTimeout = setTimeout(() => {
                            navigator.credentials.get({
                                otp: { transport: ['sms'] },
                                signal: ac.signal
                            }).then(otp => {
                                var input = document.querySelector('input[autocomplete="one-time-code"]');
                                if (input) {
                                    input.value = otp.code;  // وارد کردن خودکار کد در فیلد
                                    ac.abort();  // متوقف کردن چک کردن کد پس از دریافت
                                    clearTimeout(otpTimeout);  // پاک کردن تایمر
                                }
                            }).catch(err => {
                                console.log(err);
                            });
                        }, 2000);  // مدت زمان انتظار برای پیامک
    
                        // متوقف کردن چک کردن کد در صورت ارسال فرم
                        form.addEventListener('submit', () => {
                            ac.abort();  // توقف چک کردن کد پس از ارسال فرم
                            clearTimeout(otpTimeout);  // پاک کردن تایمر
                        });
                    }
    
                    setIsActive(true);
                    setSendCodeLoader(false);
                    setPasswordSection(true);
    
                    let pay = { text: response.data.resTp };
                    showSuccess(pay);
    
                } else if (response.data.res === 'NotOK') {
                    setSendCodeLoader(false);
    
                    let error = {
                        title: 'اخطار',
                        text: response.data.resTp,
                    };
                    showError(error);
                }
            } catch (error) {
                setSendCodeLoader(false);
                console.log(error);
            }
        }
    
        setValidated(true);
    };
    

    const login = async (event, pass) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === true) {
            event.stopPropagation();
            let ipAddress = await getIPAddress();
            console.log(ipAddress);
            let payload = {
                ip: ipAddress,
                mobile: mobile,
                password: pass
            }
            try {
                setLoginLoader(true)
                let loginRes = await loginApi(payload)
                if (loginRes && loginRes.data.res === 'OK') {
                    //save customerInfo in localStorage
                    window.localStorage.setItem('userInfo', JSON.stringify(loginRes.data))
                    setLoginLoader(false)
                    window.location.href = `/home`;

                } else {
                    setLoginLoader(false)
                    let error = {
                        title: loginRes.data.fullname,
                        text: loginRes.data.restp,
                    }
                    showError(error);
                }
            } catch (error) {
                setLoginLoader(false)
            }

        }
        setPassValidated(true);
    }
    useEffect(() => {
    }, [first])

    //setTimer
    useEffect(() => {
        let timerId;
        if (isActive && time > 0) {
            timerId = setInterval(() => {
                setTime(prevTime => prevTime - 1);
            }, 1000);
        } else if (time === 0) {
            onTimerFinish(); // Call the function when the timer reaches 0
        }
        // Cleanup interval on component unmount or when time reaches 0
        return () => clearInterval(timerId);
    }, [isActive, time]);

    //finishTimer
    const onTimerFinish = () => {
        setResendCode(true);
        setResendBtn(false);
    }

    const formatTime = (time) => {
        const minutes = String(Math.floor(time / 60)).padStart(2, '0');
        const seconds = String(time % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    }
    const changeMobile = () => {
        setCheckMobile(true)
        setPasswordSection(false)
    }
    // useEffect(() => {
    //     if (passwordSection && 'OTPCredential' in window) {
    //         // Request the OTP credential from SMS
    //         navigator.credentials.get({ otp: { transport: ['sms'] } })
    //             .then(otp => {
    //                 if (otpRef.current) {
    //                     otpRef.current.value = otp.code;
    //                     setVerifyPassword(otp.code); // Automatically set the OTP in the state
    //                 }
    //             })
    //             .catch(err => {
    //                 console.error('Error retrieving OTP:', err);
    //             });
    //     } else {
    //         console.log('Web OTP API is not supported on this browser.');
    //     }
    // }, [passwordSection]);
    return (
        <div className='login-content'>
            <Toast ref={toast} />
            <Tooltip target=".Info-login" />


            {/* password */}
            {!checkMobile && !passwordSection &&
                <div className='login-card'>
                    <img src={Leaf} className='Leaf-img-right' alt="" />
                    <img src={Leaf} className='Leaf-img-left' alt="" />
                    <div className='items'>
                        <img src={Logo} alt="" style={{width: '120px'}}/>
                        <h5 className='mt-4'>ورود به باشگاه مشتریان</h5>
                        <h6 className='mt-4'>لطفا رمز ورود خود را وارد کنید .</h6>
                        <button className='btn' style={{ color: '#669D24', float: 'left' }} onClick={changeMobile}>تغییر شماره تماس</button>
                        <Form noValidate validated={passValidated} onSubmit={(e) => login(e, password)} className="mt-2">
                            <Form.Group className="mb-3 col-12">
                                <Form.Label>رمز ورود</Form.Label>
                                <Form.Control
                                    required
                                    type="number"
                                    rows={3}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault(); // Prevent form submission
                                            login(e, password); // Call login function
                                        }
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">
                                    لطفا رمزعبور را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>

                            <button type='submit' disabled={loginLoader} className='btn btn-primary mt-4 w-100 d-flex align-items-center justify-content-center gap-2'>ادامه{loginLoader && <Loadr />}</button>
                            <button type='button' disabled={sendCodeLoader} className='btn btn-outline-primary mt-5 w-100 d-flex align-items-center justify-content-center' onClick={getPassword}>
                                ارسال رمز ورود به شماره تماس <span className='number'>{mobile} </span>{sendCodeLoader && <Loadr />}
                            </button>
                        </Form>
                    </div>
                </div>
            }

            {/* mobile */}
            {checkMobile && !passwordSection && <div className='login-card'>
                <img src={Info} className='Info-login' style={{ position: 'absolute', left: '1em', top: '1em', zIndex: '12' }} alt="" data-pr-tooltip="1. امکان ورود تنها برای افرادی امکان پذیر است که در گذشته از مجموعه طبیعی باشی خرید داشته‌اند.
2. در اولین ورود به سایت باشگاه مشتریان رمز عبور به طور خودکار به شماره شما پیامک می‌شود
3. جهت ورود در مراجعات بعدی می‌توانید از همان رمز عبور استفاده کرده یا اقدام به ثبت رمز دائم برای خود کنید
4. در صورت فراموشی رمز خود، از دکمه ارسال رمز عبور استفاده کرده تا رمز ورود مجددا برایتان پیامک شود"
                    data-pr-position="top"
                />
                <img src={Leaf} className='Leaf-img-right' alt="" />
                <img src={Leaf} className='Leaf-img-left' alt="" />
                <div className='items text-center'>
                    <img src={Logo} alt="" width={120}/>
                    <h5 className='mt-4'>ورود به باشگاه مشتریان</h5>
                    <h6 className='mt-4'>لطفا شماره تماس خود را وارد کنید.</h6>
                    <Form noValidate validated={validated} onSubmit={sendMobile} className="mt-2">
                        <Form.Group className="mb-3 col-12">
                            <Form.Label>شماره تماس</Form.Label>
                            <Form.Control
                                type="number"
                                required
                                rows={3}
                                value={mobile}
                                placeholder='09*********'

                                onChange={(e) => setMobile(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault(); // Prevent form submission
                                        sendMobile(e); // Call sendMobile function
                                    }
                                }}
                            />
                            <Form.Control.Feedback type="invalid">
                                لطفا شماره تماس خود را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>
                        <button
                            disabled={sendMobileLoader}
                            className='btn btn-primary mt-4 w-100 d-flex align-items-center justify-content-center gap-2'>
                            ادامه {sendMobileLoader && <Loadr />}
                        </button>
                    </Form>
                </div>
            </div>

            }

            {/* otp */}
            {passwordSection &&
                <div className='login-card'>
                    <img src={Leaf} className='Leaf-img-right' alt="" />
                    <img src={Leaf} className='Leaf-img-left' alt="" />
                    <div className='items'>


                        <img src={Logo} alt="" style={{width: '120px'}}/>
                        <h5 className='mt-4'>ورود به باشگاه مشتریان</h5>

                        <h6 className='mt-4'>لطفا رمز ورود خود را وارد کنید .</h6>
                        <button className='btn' style={{ color: '#669D24', float: 'left' }} onClick={changeMobile}>تغییر شماره تماس</button>
                        <Form noValidate validated={validated} onSubmit={(e) => { login(e, verifyPassword) }} className="mt-2">
                            <Form.Group className="mb-3 col-12">
                                <Form.Label>
                                    رمز ورود
                                </Form.Label>
                                <Form.Control
                                    rows={3}
                                    type="text"
                                    required
                                    ref={otpRef}
                                    autoComplete="one-time-code"
                                    inputMode="numeric"
                                    maxLength="6"
                                    pattern="\d{6}"
                                    value={verifyPassword}
                                    onChange={(e) => setVerifyPassword(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault(); // Prevent form submission
                                            login(e, verifyPassword); // Call login function
                                        }
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">
                                    لطفا رمزعبور را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <button type='submit' disabled={loginLoader} className='btn btn-primary mt-4 w-100 d-flex align-items-center justify-content-center gap-2'>ادامه{loginLoader && <Loadr />}</button>
                            <button disabled={resendBtn} className='btn btn-outline-primary mt-5 w-100 d-flex align-items-center justify-content-center gap-2 number' onClick={getPassword}>
                                {resendCode ? 'ارسال مجدد' : formatTime(time)} {sendCodeLoader && <Loadr />} </button>
                        </Form>
                    </div>
                </div>
            }
        </div>
    );
}

export default Profile;
